import { ForcedSubject, MongoAbility } from '@casl/ability';

import { AppSubjectEnum } from '../enums/app-subject.enum';
import { UserActionEnum } from '../enums/user-action.enum';

/**
 * Values of authorization actions users can perform
 */
const actions: string[] = Object.values(UserActionEnum);

/**
 * Values of authorization subjects users can perform actions on
 */
const subjects: string[] = Object.values(AppSubjectEnum);

/**
 * Authorization abilities users can perform actions on
 */
export type Abilities = [
	(typeof actions)[number],
	(
		| (typeof subjects)[number]
		| ForcedSubject<Exclude<(typeof subjects)[number], 'all'>>
	),
];

/**
 * Authorization ability granted to a user based on their role and permissions
 */
export type AppAbility = MongoAbility<Abilities>;
